import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { HALF_CONTRAST } from '../../theme';

const Container = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  position: absolute;
  background-color: white;
  border-radius: 4px;
  bottom: 68px;
  right: 10px;
  z-index: 100;
  box-shadow: 1px 2px 2px #a5a5a5;
  max-width: 200px;
`;

const Bold = styled.div`
  color: ${HALF_CONTRAST};
  text-transform: capitalize;
  font-weight: bold;
  font-size: 12px;
  display: inline;
`;
const Normal = styled.div`
  color: ${HALF_CONTRAST};
  text-transform: capitalize;
  font-size: 12px;
  display: inline;
`;

const mapState = ({ hoveredParcel }) => ({ hoveredParcel: hoveredParcel.displayParcel });
const exclude = ['point'];

export const HoveredParcel = () => {
  const { hoveredParcel } = useSelector(mapState);

  if (!hoveredParcel) return null;

  return (
    <Container>
      {Object.keys(hoveredParcel).map((key) => {
        if (exclude.includes(key)) return null;
        const value = hoveredParcel[key];
        if (!value) return null;

        return (
          <div key={key}>
            <Bold>
{key.split('_').join(' ')}
:
            </Bold>
            <Normal>
              &nbsp;
              {value}
            </Normal>
          </div>
        );
      })}
    </Container>
  );
};
